import React from 'react';
import { Material } from './Crafting';
import { getRarityIcon } from '../utils/craftingUtils';

interface Props {
  inventory: Material[];
}

function rarityBadgeClass(rarity: string): string {
  switch (rarity.toLowerCase()) {
    case 'uncommon':  return 'cf-badge--green';
    case 'rare':      return 'cf-badge--blue';
    case 'epic':      return 'cf-badge--purple';
    case 'legendary': return 'cf-badge--amber';
    default:          return 'cf-badge--dim';
  }
}

const CraftingInventoryTab: React.FC<Props> = ({ inventory }) => (
  <div className="crafting-tab-content">
    <div className="crafting-section-header crafting-section-header--gold">
      Material Inventory
    </div>

    {inventory.length === 0 ? (
      <div className="crafting-empty">
        <p>No materials in inventory</p>
        <small>Defeat enemies in battle to collect crafting materials</small>
      </div>
    ) : (
      <div className="crafting-inv-list">
        {inventory.map(item => (
          <div key={item.id} className="crafting-inv-row">
            <div className="crafting-inv-icon">{getRarityIcon(item.materialRarity)}</div>

            <div className="crafting-inv-info">
              <div className="crafting-inv-name">{item.materialName}</div>
              <div className="crafting-inv-meta">
                <span className="crafting-inv-type">{item.materialType}</span>
                <span className={`cf-badge ${rarityBadgeClass(item.materialRarity)}`}>
                  {item.materialRarity}
                </span>
              </div>
              <div className="crafting-inv-desc">{item.description}</div>
            </div>

            <div className="crafting-inv-bar-col">
              <div className="crafting-inv-qty">×{item.quantity}</div>
              <div className="cf-stock-bar">
                <div
                  className="cf-stock-fill"
                  style={{ width: `${Math.min(100, (item.quantity / Math.max(item.quantity, 20)) * 100)}%`, background: 'var(--gold)' }}
                />
              </div>
              <div className="crafting-inv-value">{item.baseValue}g each</div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default CraftingInventoryTab;
